import {InjectionKey} from 'vue'

const useRouteKey = Symbol() as InjectionKey<Function>
const useAccountsStoreKey = Symbol() as InjectionKey<Function>
const useSubAccountsKey = Symbol() as InjectionKey<Function>
const getCommandsKey = Symbol() as InjectionKey<Function>
const useVatServiceKey = Symbol() as InjectionKey<Function>


export {
    useRouteKey,
    useAccountsStoreKey,
    useSubAccountsKey,
    getCommandsKey,
    useVatServiceKey
}